import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getIsAdmin } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const ContextView = ({ data }) => {
    const isAdmin = useSelector(getIsAdmin);

    useEffect(() => {
        const yOffset = -document.getElementsByClassName("main-header")[0].offsetHeight;
        const element = document.getElementById("contextResult");
        const posi = element.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({ top: posi, behavior: "smooth" });
    }, []);

    return (
        <div id="contextResult">
            {isAdmin && data.result && (
                <div style={{ margin: "20px 0px 10px" }}>
                    <TextFieldMultiline
                        disabled
                        fullWidth
                        rows={5}
                        margin={"none"}
                        label={getLocalizedString("sqlContextResult")}
                        value={JSON.stringify(data.result)}
                    />
                </div>
            )}
            {data.comment && (
                <div style={{ margin: "20px 0px 10px" }}>
                    <TextFieldMultiline
                        disabled
                        fullWidth
                        rows={5}
                        margin={"none"}
                        label={getLocalizedString("contextComments")}
                        value={data.comment}
                    />
                </div>
            )}
        </div>
    );
};

export default ContextView;
